export default {
    title: '添加旅客資料'
}
